var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1175 12.1715C21.1409 13.1344 19.6209 14.4928 17.8468 15.6018C16.0516 16.724 14.1403 17.5 12.3487 17.5C10.5572 17.5 8.64591 16.724 6.8507 15.6018C5.0766 14.4928 3.55655 13.1344 2.58001 12.1715C2.51696 12.1093 2.5 12.0484 2.5 12C2.5 11.9516 2.51696 11.8907 2.58 11.8285C3.55655 10.8656 5.0766 9.50723 6.8507 8.39819C8.64591 7.27595 10.5572 6.5 12.3487 6.5C14.1403 6.5 16.0516 7.27595 17.8468 8.39819C19.6209 9.50723 21.1409 10.8656 22.1175 11.8285C22.1805 11.8907 22.1975 11.9516 22.1975 12C22.1975 12.0484 22.1805 12.1093 22.1175 12.1715ZM23.1707 10.7605C23.8731 11.4531 23.8731 12.5469 23.1707 13.2395C21.1317 15.2501 16.7402 19 12.3487 19C7.95726 19 3.56578 15.2501 1.52681 13.2395C0.824398 12.5469 0.824398 11.4531 1.52681 10.7605C3.56578 8.74989 7.95726 5 12.3487 5C16.7402 5 21.1317 8.74989 23.1707 10.7605ZM14.8487 12C14.8487 13.3807 13.7295 14.5 12.3487 14.5C10.968 14.5 9.84875 13.3807 9.84875 12C9.84875 10.6193 10.968 9.5 12.3487 9.5C13.7295 9.5 14.8487 10.6193 14.8487 12ZM16.3487 12C16.3487 14.2091 14.5579 16 12.3487 16C10.1396 16 8.34875 14.2091 8.34875 12C8.34875 9.79086 10.1396 8 12.3487 8C14.5579 8 16.3487 9.79086 16.3487 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassword);
export default __webpack_public_path__ + "static/media/ViewPassword.4bf9c7d8a5e4bce190e754cb254695eb.svg";
export { ForwardRef as ReactComponent };